"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getShadeBorder = void 0;
var _constants = require("../constants");
const getShadeBorder = (background, theme) => _constants.WHITE_COLORS.includes(background) ? `1px solid ${theme.palette.grey[200]}` : undefined;
exports.getShadeBorder = getShadeBorder;
//# sourceMappingURL=getShadeBorder.js.map